<script lang="ts">
const __DsBlock = {
	category: 'basic',
	events: [
		{
			name: 'action',
			payload: [],
		},
	],
	options: [
		{
			name: 'title',
		},
		{
			name: 'description',
		},
		{
			name: 'icon',
			block: BuiltinBlockIds.InputIcon,
		},
		{
			type: 'separator',
			label: 'Action',
		},
		{
			name: 'actionLabel',
		},
		{
			name: 'actionIcon',
			block: BuiltinBlockIds.InputIcon,
		},
	],
	hidden: blockContextIsContentPage,
}
</script>
<script lang="ts" setup>
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { defineBlock, useBlockInEditorContext } from '#layers/block-engine';
import { useTranslationUtils } from '#layers/i18n';
import { blockContextIsContentPage } from '~/utils/block';

defineProps<{
	icon?: string;
	title?: string;
	description?: string;
	actionLabel?: string;
	actionIcon?: string;
}>();

defineEmits<{
	action: [];
}>();

;

const { isPreview } = useBlockInEditorContext();

const { translateString } = useTranslationUtils();
</script>

<template>
	<DEmpty
		:icon
		:title="translateString(isPreview ? '$t:organization.projects.listing.empty.title' : title)"
		:description="translateString(isPreview ? '$t:organization.projects.listing.empty.description' : description)"
		:action-button-label="actionLabel ? translateString(actionLabel) : undefined"
		:action-button-icon="actionIcon"
		@action="$emit('action')"
	/>
</template>
